import React from 'react'
function clearParentState(name){
    let clear = {}
    clear.target ={}
    clear.target.name = name
    clear.target.value = undefined
    return clear
}

export default clearParentState